//! Externals
import { useState, useEffect, useCallback } from 'react'
import router from 'next/router'

//! HOC's
import { withUserContext, withUIContext } from 'context'


//! Helpers
import { diffForHumans } from 'helpers/_functions'

//* Components
import { Text, Avatar, CustomLink, Icon, LikesCount } from 'components/common'
import { SubmitReportPopup } from 'components/pages'

const SingleComment = (props) => {

    const { checkCommentLiked, openPopup } = props

    const [reportPopup, setReportPopup] = useState(false)

    const [isLiked, setIsLiked] = useState(checkCommentLiked(props.id))
    const [likesCount, setLikesCount] = useState(props.likesCount)

    useEffect(() => {
        if (reportPopup) {
            document.addEventListener('click', clickHandler)
        }

        return () => {
            document.removeEventListener('click', clickHandler)
        }
    }, [reportPopup])

    const clickHandler = useCallback((e) => {
        if (!(!!e.path.find((el) => el.classList?.contains('icon-pop')))) {
            let isExist = e?.path.find(el => el.classList?.contains('pop'));

            if (!isExist) {
                setReportPopup(false)
            }
        }
    }, []);

    const toggleCommentLike = () => {
        if (!props.isFinished) {
            if (props.isLoggedIn) {
                return props.toggleCommentLike({ comment_id: props.id }).then(count => {
                    setIsLiked(!isLiked)
                    setLikesCount(count)
                })
            } else {
                router.push(`${router.asPath}?c=login`)
            }
        }
    }

    const handleReportPopUp = () => {
        if (!props.isLoggedIn) {
            router.push(`${router.asPath}?c=login`)
        } else {
            openPopup(<SubmitReportPopup />, {
                title: props.text,
                url: router.asPath
            })
        }
    }

    return (
        <div className='single-comment flexBoxColumn'>
            <div className='hdr flexBox spaceBetween alignMiddle'>
                <div className='name-pic flexBox spaceBetween alignMiddle'>
                    <Avatar src={props.user.avatar} />
                    <Text tag={'p'} className='name h7 PopSemi' text={`${props.user.name} ${props.user.surname}`} />
                </div>
                <div className='date flexBox spaceBetween alignMiddle'>
                    <Text tag={'p'} className='com-date h8 PopSemi darkGrey' text={diffForHumans(props.commentDate)} />
                    <div className='report blockk flexBox alignMiddle'>
                        <Icon className='darkGrey cursorPointer op-burgerDots icon-pop' onClick={() => setReportPopup(!reportPopup)} />
                        <div className={`report-popup pop flexBoxColumn ${reportPopup ? 'active' : ''}`}>
                            {props.user.id != props.currentUser?.id && (
                                <Text
                                    tag='h5'
                                    className='sharer PopReg h5 cursorPointer'
                                    text='Report'
                                    onClick={handleReportPopUp}
                                />
                            )}
                            <CustomLink url={`/${props.user.username}`}>
                                <Text tag='h5' className='sharer PopReg h5' text='Go to creators page' />
                            </CustomLink>
                        </div>
                    </div>
                </div>
            </div>
            <p className='const14 PopReg' dangerouslySetInnerHTML={{ __html: props.text }}></p>
            <div className='ftr flexBox'>
                <LikesCount
                    onClick={toggleCommentLike}
                    className={`op-heart cursorPointer ${isLiked ? 'active' : ''}`}
                    likesCount={likesCount}
                    likeType={'default'}
                />
                <div className='reply flexBox cursorPointer' onClick={() => props.replyComment(props.user.name)}>
                    <Icon className='op-arrowToLeft grey' />
                    <Text tag={'p'} className='h8 PopSemi grey' text={'Reply'} />
                </div>
            </div>
        </div>
    )
}

export default withUserContext(withUIContext(SingleComment, ['openPopup']), ['toggleCommentLike', 'checkCommentLiked', 'isLoggedIn', 'currentUser'])
